
import React from 'react';
import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import { write, useSnap } from '../store'
import Turkishtos1 from './locale/Turkishtos1';
import Turkishtos2 from './locale/Turkishtos2';
import EngWarning from './locale/engWarning';
import { locale } from './locale';


function NewModal({ type, title = 'Terms of service' }) {
    const read = useSnap()
    const timerRef = React.useRef()

    React.useEffect(() => {
        if (type !== 'tos1' && type !== 'tos2' && type !== 'welcome') {
            timerRef.current = setTimeout(() => {
                console.log('⏳⏳ OUT')
                handleClick()
            }, 180000);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type]);
    // const [content, setContent] = React.useState();

    // console.log('type', type)

    const RenderIt = () => {
        switch (type) {
            case 'tabCTRL':
                return <EngWarning />
            case 'tos1':
                return <Turkishtos1 />
            case 'tos2':
                return <Turkishtos2 />
            case 'welcome':
                return locale[read.user.language].instruction.welcome
            case 'reading':
                return locale[read.user.language].instruction.reading
            case 'listening':
                return locale[read.user.language].instruction.listening
            case 'speaking':
                return locale[read.user.language].instruction.speaking
            case 'writing':
                return locale[read.user.language].instruction.writing
            default:
                break;
        }
    }
    function handleClick(t) {
        //! MUST BE ENABLED THE FIRST 2 LINES
        console.log('🟢🟢', 'clicked')
        clearTimeout(timerRef.current)
        write.instruction[type] = true
        localStorage.setItem(type, true);

        // console.log(localStorage.getItem(type), '🟢🟢')

    }



    return (
        <>
            <div
                className={`assessment-modal-overlay fixed inset-0 z-50 ${read.instruction[type] ? 'hidden' : ''} overflow-y-auto bg-slate-950/45 px-3 py-4 backdrop-blur-sm sm:px-6 sm:py-8`}
                role="dialog"
                aria-modal="true"
                aria-labelledby={`assessment-modal-title-${type}`}
            >
                <div className="assessment-modal-panel relative mx-auto flex w-full max-w-3xl flex-col overflow-hidden rounded-3xl bg-white shadow-2xl shadow-slate-950/25">
                    {/* Modal content */}
                    <div className="flex min-h-0 flex-1 flex-col bg-white">
                        {/* Modal header */}
                        <div className="flex flex-shrink-0 items-start justify-between gap-4 border-b border-slate-200 p-4 sm:p-5">
                            <h3 id={`assessment-modal-title-${type}`} className="min-w-0 break-words text-lg font-extrabold leading-7 text-slate-950 sm:text-xl">
                                {title}
                            </h3>
                            <div className="flex-shrink-0">
                                <CountdownCircleTimer
                                    isPlaying
                                    isGrowing
                                    size={32}
                                    duration={240}
                                    strokeWidth={3}
                                    colors={['#008000', '#F7B801', '#A30000']}
                                    colorsTime={[120, 60, 10]}
                                />
                            </div>
                            
                        </div>
      
                        {/* Modal body */}
                        <div className="assessment-modal-body min-h-0 flex-1 space-y-5 overflow-auto p-4 text-sm leading-6 text-slate-700 sm:p-6 sm:text-base">



                            <RenderIt />


                        </div>
                        {/* Modal footer */}
                        <div className="flex flex-shrink-0 items-center justify-center border-t border-slate-200 p-4 sm:p-5">
                            <button onClick={handleClick} data-modal-hide="staticModal" type="button" className="min-h-[44px] w-full rounded-xl bg-blue-700 px-5 py-2.5 text-center text-sm font-bold text-white shadow-lg shadow-blue-700/20 transition-colors hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-200 sm:w-auto">{locale[read.user.language].button.understand}</button>

                        </div>
                    </div>
                </div>
            </div>



        </>
    )


}




export default NewModal
